var _style, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _defs17, _defs18, _defs19, _defs20, _defs21, _defs22, _defs23, _defs24, _defs25, _defs26, _defs27, _defs28, _defs29, _defs30, _defs31, _defs32, _defs33;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdenGreenLogoMin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 436.6 225.9",
    style: {
      enableBackground: "new 0 0 436.6 225.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000072243569109364803550000000967271109917183409_);}\r\n\t.st1{fill:url(#SVGID_00000157285402744267660640000012992596830690024365_);}\r\n\t.st2{clip-path:url(#SVGID_00000016035077730683314810000015040516189473833607_);}\r\n\t.st3{fill:url(#SVGID_00000072964503349441893600000011586032462570375095_);}\r\n\t.st4{clip-path:url(#SVGID_00000101802308280248458140000000267416019910189489_);}\r\n\t.st5{fill:url(#SVGID_00000172417601058814728940000004055691079648173449_);}\r\n\t.st6{clip-path:url(#SVGID_00000075880914338303295440000013662435075357231254_);}\r\n\t.st7{fill:url(#SVGID_00000026871475843698740900000015496383349373759915_);}\r\n\t.st8{clip-path:url(#SVGID_00000150081881096548764340000000104528331064430232_);}\r\n\t.st9{fill:url(#SVGID_00000165941923534526228630000009488254778952675492_);}\r\n\t.st10{clip-path:url(#SVGID_00000022520094039427222130000001579606528084551075_);}\r\n\t.st11{fill:url(#SVGID_00000043416395612933711210000012704824175712493195_);}\r\n\t.st12{clip-path:url(#SVGID_00000100363611602419083410000017512054744900254391_);}\r\n\t.st13{fill:url(#SVGID_00000164496432577488101140000004904039458541045432_);}\r\n\t.st14{clip-path:url(#SVGID_00000018195399301405505830000000618982771196745113_);}\r\n\t.st15{fill:url(#SVGID_00000174573999532768472690000005115507973201892495_);}\r\n\t.st16{clip-path:url(#SVGID_00000137818673718649432070000001202660060542901384_);}\r\n\t.st17{fill:url(#SVGID_00000150076306723211073130000002048295481777443736_);}\r\n\t.st18{clip-path:url(#SVGID_00000034786989399688166250000003218177333014582716_);}\r\n\t.st19{fill:url(#SVGID_00000000207513143752945900000004710384150519933579_);}\r\n\t.st20{clip-path:url(#SVGID_00000036937705180559157810000016168572820191344768_);}\r\n\t.st21{fill:url(#SVGID_00000093897634181769499200000017314760271333761409_);}\r\n\t.st22{clip-path:url(#SVGID_00000051351182744455753110000013034295200623226513_);}\r\n\t.st23{fill:url(#SVGID_00000000197292176027251900000016767790351877260223_);}\r\n\t.st24{clip-path:url(#SVGID_00000031209430531539924560000011426456368050123680_);}\r\n\t.st25{fill:url(#SVGID_00000114045120450904445360000013167323381451450001_);}\r\n\t.st26{clip-path:url(#SVGID_00000070836035859719681020000000052420919108605605_);}\r\n\t.st27{fill:url(#SVGID_00000101094692239035703300000001545141355280800910_);}\r\n\t.st28{clip-path:url(#SVGID_00000034085990485514026000000004367211923469024950_);}\r\n\t.st29{fill:url(#SVGID_00000160907801874032260920000016229463858860504253_);}\r\n\t.st30{clip-path:url(#SVGID_00000107571699798506994430000014836454038400613566_);}\r\n\t.st31{fill:url(#SVGID_00000166676157514696525960000001103346926594338705_);}\r\n\t.st32{clip-path:url(#SVGID_00000061437618192496779820000005161804968950366611_);}\r\n\t.st33{fill:url(#SVGID_00000110463853099453029420000004906576781520070331_);}\r\n\t.st34{clip-path:url(#SVGID_00000135681444240506534130000007893976507810573697_);}\r\n\t.st35{fill:url(#SVGID_00000024681519602030083890000001092103834200204971_);}\r\n\t.st36{clip-path:url(#SVGID_00000106860077331202677980000016025270074863701396_);}\r\n\t.st37{fill:url(#SVGID_00000136374039156864926930000017124131390282449059_);}\r\n\t.st38{clip-path:url(#SVGID_00000106861493347715366270000002657676068180984479_);}\r\n\t.st39{fill:url(#SVGID_00000054959207568868633870000013911253678272963482_);}\r\n\t.st40{clip-path:url(#SVGID_00000123441038204508112810000008490959877056507011_);}\r\n\t.st41{fill:url(#SVGID_00000130627721843353997200000004366444248567827093_);}\r\n\t.st42{clip-path:url(#SVGID_00000065796078565863495910000015824657497451020425_);}\r\n\t.st43{fill:url(#SVGID_00000126318139979758663170000014953196508453293470_);}\r\n\t.st44{clip-path:url(#SVGID_00000137126788072998469710000013438565012449022862_);}\r\n\t.st45{fill:url(#SVGID_00000182508536658401001280000011546086781174471600_);}\r\n\t.st46{clip-path:url(#SVGID_00000180331092901345666760000013816012115051705224_);}\r\n\t.st47{fill:url(#SVGID_00000178171086716817562270000008125833296036259745_);}\r\n\t.st48{clip-path:url(#SVGID_00000023975668887636565500000003823116923452063136_);}\r\n\t.st49{fill:url(#SVGID_00000066490008079133124650000014065136393887914166_);}\r\n\t.st50{clip-path:url(#SVGID_00000105386500877926126180000015913967682061230773_);}\r\n\t.st51{fill:url(#SVGID_00000058588892105607282150000010500153751627062178_);}\r\n\t.st52{clip-path:url(#SVGID_00000039813031711624669310000007722729932291261105_);}\r\n\t.st53{fill:url(#SVGID_00000098914869307433911620000000383161955731919288_);}\r\n\t.st54{clip-path:url(#SVGID_00000145022885278769769010000004345313182648138896_);}\r\n\t.st55{fill:url(#SVGID_00000059286615811583267020000010478353429434633111_);}\r\n\t.st56{clip-path:url(#SVGID_00000013872441358214501920000007032195267987027387_);}\r\n\t.st57{fill:url(#SVGID_00000130632914460567051770000014842825840862196657_);}\r\n\t.st58{clip-path:url(#SVGID_00000079468468857408342960000000542105664264843659_);}\r\n\t.st59{fill:url(#SVGID_00000152257472434349309730000012691285467781095821_);}\r\n\t.st60{clip-path:url(#SVGID_00000137843186320849855060000001994340876348719764_);}\r\n\t.st61{fill:url(#SVGID_00000101812517950045603860000017610526788777589165_);}\r\n\t.st62{clip-path:url(#SVGID_00000158709051840662959460000017730713051950779031_);}\r\n\t.st63{fill:url(#SVGID_00000157307976768098573620000003955529775803763080_);}\r\n\t.st64{clip-path:url(#SVGID_00000072274638499196985140000010023220759911266239_);}\r\n\t.st65{fill:url(#SVGID_00000089532095426204509310000007733048007922931848_);}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000110468285442790303180000007875682931632612753_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M43,181.6c-9.3-9.3-16.2-22.2-20.5-38.4c-0.7-2.5-1.3-5-1.8-7.6c0-0.1,0-0.1,0-0.2 c-3.1-15.2-3.1-30.9,0-46.1l0.1-0.3c3.4-16.7,9.9-33.7,22.2-46c9.3-9.3,22.2-16.2,38.4-20.5c13.9-3.5,28.3-5.2,42.7-5.1 c3.8,0,7.6,0.1,11.4,0.3c1,19,0.4,57.1-17.6,83.2V35.4l-17,17v65.5c-2.7,1.8-5.5,3.5-8.5,5V60.8l-17,17.1v51.8 c-1.2,0.4-2.4,0.7-3.6,1c-1.6,0.4-3.2,0.8-4.9,1.2V86.4l-17,17v31.3c-3.8,0.4-7.7,0.7-11.7,0.9c0.2,1.1,0.5,2.2,0.8,3.2 c3.5,13.2,8.9,23.6,16.1,30.8c7.4,7.4,18.2,12.9,32,16.4c9.3,2.4,31.7,4.1,31.7,4.1l0,0c2.9,0.1,10.5,0.1,10.5,0.1l2.3,17 c0,0-3.1,0-7.3,0C100.7,207.2,64.6,203.2,43,181.6 M30.7,30.7C18.9,42.4,11.5,57.3,6.9,72.5H6.7l-0.4,1.9 c-10.8,37.7-4.6,77.1-4.6,77.1s2,0.3,5.6,0.7c5.1,17,13.1,31,23.6,41.5C42.8,205.5,58.9,214,78.8,219 c14.9,3.6,30.2,5.3,45.5,5.2c4.1,0,8.2-0.1,12.2-0.3l16.9-1.1l-8.6-49.7c-3,0.2-15.8,0.2-18.8,0.2c-2.2,0-4.4,0-6.5-0.1 l-4.6-0.2c-8-0.4-15.9-1.5-23.6-3.3c-10.8-2.7-18.9-6.7-24.1-11.9c-2-2.1-3.8-4.4-5.2-6.9c21.3-3.5,44.1-11.5,60.7-28.1 C163.9,81.2,151.5,1.8,151.5,1.8c-9.1-1.2-18.2-1.8-27.4-1.8C97.2,0,56.5,4.9,30.7,30.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044862031297617943320000003413758671428197792_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044862031297617943320000003413758671428197792_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097461102326720438360000010038847099291867320_",
    gradientUnits: "userSpaceOnUse",
    x1: -1046.5919,
    y1: 13.0375,
    x2: -1045.5919,
    y2: 13.0375,
    gradientTransform: "matrix(262.7054 150.8793 -150.8793 262.7054 276845.9062 154512.1562)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25D973"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2FBB82"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000097461102326720438360000010038847099291867320_)"
    },
    points: "-101.2,168.6 37.4,-72.7  260.7,55.6 122.2,296.9  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000177452064650057548890000014979263097193019793_",
    d: "M135.5,17.8c1,19,0.4,57-17.6,83.2V35.4l-17,17v65.5 c-2.7,1.8-5.5,3.5-8.5,5V60.8L92.2,61L75.4,77.9v51.8c-1.2,0.4-2.4,0.7-3.6,1c-1.6,0.4-3.2,0.8-4.9,1.2V86.4l-17,17v31.3 c-3.8,0.4-7.7,0.7-11.7,0.9c0.2,1.1,0.5,2.2,0.8,3.2c1.2,4.7,2.8,9.4,4.8,13.8c25.5-1.8,57.1-8.7,78.6-30.2 C163.8,81.3,151.5,1.8,151.5,1.8L135.5,17.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000028322979977421585220000017427795959731432614_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000177452064650057548890000014979263097193019793_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000028322979977421585220000017427795959731432614_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109000946323261095920000000065387804586849964_",
    gradientUnits: "userSpaceOnUse",
    x1: -1039.4565,
    y1: 10.8152,
    x2: -1038.4565,
    y2: 10.8152,
    gradientTransform: "matrix(59.2975 50.2879 -50.2879 59.2975 62258.0273 51687.6758)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3FA9F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D76C9"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000109000946323261095920000000065387804586849964_)"
    },
    points: "-36.3,89.6 90.7,-60.2  238.3,64.9 111.3,214.7  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000125601601430731966710000005062582680726064772_",
    d: "M1.7,151.5c7.9,1.1,15.9,1.6,23.9,1.7 c-1.2-3.2-2.2-6.5-3.1-10c-0.7-2.5-1.3-5-1.8-7.6c0-0.1,0-0.1,0-0.2c-0.2-0.8-0.3-1.6-0.5-2.5L1.7,151.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000043415754991712316170000005779994599328340866_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000125601601430731966710000005062582680726064772_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000043415754991712316170000005779994599328340866_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000196987501639975330000013293515376177778582_",
    gradientUnits: "userSpaceOnUse",
    x1: -1039.4565,
    y1: 10.8287,
    x2: -1038.4565,
    y2: 10.8287,
    gradientTransform: "matrix(59.2975 50.2879 -50.2879 59.2975 62189.7188 51768.2305)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3FA9F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D76C9"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000000196987501639975330000013293515376177778582_)"
    },
    points: "-8.2,144.7 11.8,121.1  35.7,141.4 15.7,165  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000139251624188104564000000012785683806199627665_",
    points: "169.4,37.4 169.4,93.1 217.6,93.1 217.6,82.9  181,82.9 181,69.5 216.2,69.5 216.2,59.8 181,59.8 181,47.7 216.9,47.7 216.9,37.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003808858625778746870000001324266878390445726_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000139251624188104564000000012785683806199627665_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000003808858625778746870000001324266878390445726_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049185752159821841480000000113686361497547432_",
    gradientUnits: "userSpaceOnUse",
    x1: -1046.3484,
    y1: 9.0381,
    x2: -1045.3484,
    y2: 9.0381,
    gradientTransform: "matrix(20.2763 156.1188 -156.1188 20.2763 22814.998 163193.6719)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25D973"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2FBB82"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000049185752159821841480000000113686361497547432_)"
    },
    points: "162.3,38.4 216.8,31.3  224.7,92.2 170.2,99.3  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000130648210741381552690000009020123908663760533_",
    d: "M169.6,37.7h47.1v9.8h-35.9v12.6H216v9.2h-35.2v13.8 h36.6v9.8h-47.8V37.7z M216.7,37.2h-47.5v56.1h48.7V82.7h-36.6v-13h35.2V59.6h-35.2V47.9h35.9V37.2H216.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052818911903443750470000004564728709080157837_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000130648210741381552690000009020123908663760533_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000052818911903443750470000004564728709080157837_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017511979548135652130000017241344730827636124_",
    gradientUnits: "userSpaceOnUse",
    x1: -1046.3484,
    y1: 9.0381,
    x2: -1045.3484,
    y2: 9.0381,
    gradientTransform: "matrix(20.2763 156.1188 -156.1188 20.2763 22814.998 163193.6719)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25D973"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2FBB82"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000017511979548135652130000017241344730827636124_)"
    },
    points: "162,38.1 217,31 225,92.4  170,99.6  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000014621997553780380910000018330683646584123287_",
    d: "M243.6,83.3c-1.6-0.6-3.2-1.5-4.5-2.6 c-1.2-1.1-2.2-2.4-2.9-3.8c-0.7-1.5-1-3-1-4.7c0-1.7,0.3-3.4,1-4.9c0.7-1.5,1.7-2.8,2.9-3.9c1.4-1.2,3-2.1,4.7-2.6 c2-0.7,4.2-1,6.4-1c1.2,0,2.4,0.1,3.6,0.3c1.2,0.2,2.5,0.5,3.7,0.8c1.2,0.4,2.4,0.9,3.6,1.5c1.1,0.6,2.2,1.3,3.2,2.1v14.3 c-0.9,0.9-1.8,1.6-2.9,2.3c-1.2,0.7-2.4,1.3-3.6,1.8c-1.3,0.5-2.6,0.9-4,1.1c-1.4,0.3-2.8,0.4-4.2,0.4 C247.5,84.3,245.5,84,243.6,83.3 M264.3,37.5v16.4c-0.9-0.5-1.9-1-2.9-1.3c-1.3-0.5-2.5-0.9-3.9-1.2c-1.4-0.3-2.8-0.6-4.3-0.8 c-1.5-0.2-3-0.3-4.5-0.3c-3.4,0-6.7,0.5-9.9,1.5c-2.9,1-5.6,2.5-7.9,4.4c-2.2,1.9-4,4.3-5.2,6.9c-2.5,5.7-2.5,12.2-0.1,17.9 c1.2,2.6,2.9,4.9,5,6.8c2.3,2,4.9,3.5,7.7,4.4c3.2,1.1,6.5,1.6,9.8,1.6c1.5,0,3.1-0.1,4.6-0.4c1.5-0.2,3-0.6,4.5-1 c1.4-0.4,2.7-0.9,4.1-1.5c1-0.5,2-1,3-1.6v3.7h10.9V37.5L264.3,37.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000067918905625076277920000016042930838013509780_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000014621997553780380910000018330683646584123287_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000067918905625076277920000016042930838013509780_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112613388164547060230000015365992790478301328_",
    gradientUnits: "userSpaceOnUse",
    x1: -1046.3484,
    y1: 9.0487,
    x2: -1045.3484,
    y2: 9.0487,
    gradientTransform: "matrix(20.2763 156.1188 -156.1188 20.2763 22871.6758 163186.3281)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25D973"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2FBB82"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000112613388164547060230000015365992790478301328_)"
    },
    points: "216.6,38.4 274.3,30.9  282.4,92.9 224.7,100.4  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000013168215907327964880000017903127634936536241_",
    d: "M243.7,83.1c-1.6-0.6-3.1-1.4-4.4-2.6 c-1.2-1-2.1-2.3-2.8-3.8c-0.7-1.4-1-3-1-4.6c0-1.7,0.3-3.3,1-4.8c0.7-1.5,1.6-2.8,2.9-3.8c1.4-1.2,2.9-2,4.6-2.6 c2-0.7,4.1-1,6.3-1c1.2,0,2.4,0.1,3.6,0.3c1.2,0.2,2.5,0.5,3.7,0.8c1.2,0.4,2.4,0.9,3.6,1.5c1.1,0.6,2.1,1.2,3.1,2v14.1 c-0.8,0.8-1.8,1.6-2.8,2.2c-1.1,0.7-2.4,1.3-3.6,1.8c-1.3,0.5-2.6,0.9-4,1.1c-1.4,0.3-2.8,0.4-4.2,0.4 C247.6,84.1,245.6,83.8,243.7,83.1 M243.8,60.5c-1.8,0.6-3.4,1.5-4.8,2.7c-1.3,1.1-2.3,2.5-3,4c-0.7,1.6-1,3.3-1,5 c0,3.3,1.5,6.5,4,8.6c1.3,1.2,2.9,2.1,4.6,2.7c1.9,0.7,4,1,6,1c1.4,0,2.8-0.1,4.2-0.4c1.4-0.3,2.7-0.6,4-1.1 c1.3-0.5,2.5-1.1,3.7-1.8c1.1-0.7,2.1-1.5,3-2.4V64.3c-1-0.8-2.2-1.6-3.4-2.2c-1.2-0.6-2.4-1.1-3.6-1.5 c-1.2-0.4-2.5-0.6-3.7-0.8c-1.2-0.2-2.4-0.3-3.6-0.3C248,59.6,245.8,59.9,243.8,60.5 M264.5,37.7H275v55.2h-10.5V89 c-1,0.7-2.1,1.3-3.2,1.8c-1.3,0.6-2.6,1.1-4,1.5c-1.5,0.4-3,0.8-4.5,1c-1.5,0.2-3,0.4-4.6,0.4c-3.3,0-6.6-0.5-9.7-1.6 c-2.8-0.9-5.4-2.4-7.6-4.4c-2.1-1.9-3.8-4.2-5-6.8c-2.4-5.7-2.4-12.1,0.1-17.7c1.2-2.6,3-5,5.2-6.9c2.3-2,5-3.4,7.9-4.4 c3.2-1.1,6.5-1.6,9.9-1.5c1.5,0,3,0.1,4.5,0.3c1.4,0.2,2.8,0.4,4.2,0.8c1.3,0.3,2.6,0.7,3.8,1.2c1.1,0.4,2.2,0.9,3.2,1.5 L264.5,37.7z M275,37.3h-10.9v16.2c-0.8-0.4-1.7-0.8-2.6-1.2c-1.3-0.5-2.6-0.9-3.9-1.2c-1.4-0.3-2.8-0.6-4.3-0.8 c-1.5-0.2-3-0.3-4.6-0.3c-3.4,0-6.8,0.5-10,1.6c-2.9,1-5.6,2.5-8,4.5c-2.2,1.9-4,4.3-5.3,7c-2.5,5.8-2.5,12.3-0.1,18.1 c1.2,2.6,2.9,5,5.1,6.9c2.3,2,4.9,3.5,7.8,4.5c3.2,1.1,6.5,1.6,9.9,1.6c1.6,0,3.1-0.1,4.6-0.4c1.5-0.2,3-0.6,4.5-1 c1.4-0.4,2.8-0.9,4.1-1.5c0.9-0.4,1.8-0.9,2.6-1.4v3.6h11.3V37.3H275z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000022530759062387314750000007347110185869146559_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013168215907327964880000017903127634936536241_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022530759062387314750000007347110185869146559_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127726516777619510370000003219908195754887323_",
    gradientUnits: "userSpaceOnUse",
    x1: -1046.3484,
    y1: 9.0487,
    x2: -1045.3484,
    y2: 9.0487,
    gradientTransform: "matrix(20.2763 156.1188 -156.1188 20.2763 22871.6797 163186.3125)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25D973"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2FBB82"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000127726516777619510370000003219908195754887323_)"
    },
    points: "216.4,38.2 274.5,30.6  282.7,93.1 224.5,100.7  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000133526831427349344040000001685388100157195432_",
    d: "M296.2,64.8c0.9-1,1.9-1.9,3-2.6 c1.3-0.8,2.7-1.4,4.2-1.8c1.7-0.5,3.6-0.7,5.4-0.7c1.7,0,3.4,0.2,5.1,0.6c1.4,0.4,2.8,1,4,1.7c1.1,0.7,2.1,1.6,2.9,2.6 c0.7,0.9,1.2,1.8,1.6,2.9h-27.8C295,66.6,295.5,65.7,296.2,64.8 M297.2,52c-2.9,1.1-5.7,2.7-8,4.8c-2.1,1.9-3.8,4.3-5,6.9 c-1.2,2.6-1.8,5.4-1.8,8.2c0,3,0.6,5.9,1.8,8.6c1.2,2.7,3.1,5.1,5.4,7c2.7,2.1,5.7,3.7,8.9,4.7c4,1.2,8.2,1.8,12.3,1.7 c1.8,0,3.6-0.1,5.3-0.2s3.3-0.4,4.8-0.7c1.5-0.3,3-0.7,4.4-1.2c1.4-0.5,2.8-1.1,4.2-1.7l0.2-0.1l-3.7-8.4l-0.2,0.1 c-2.2,0.8-4.5,1.4-6.8,1.9c-2.3,0.5-4.7,0.8-7.1,0.8c-2.2,0-4.4-0.2-6.5-0.6c-1.8-0.3-3.5-0.9-5.2-1.7c-1.4-0.7-2.6-1.6-3.7-2.6 c-0.9-0.9-1.5-1.9-2-3.1h39.4v-0.2c0.1-0.4,0.1-0.8,0.1-1.3c0-0.5,0-0.9,0-1.3c0-3.1-0.6-6.2-1.8-9.1c-1.2-2.8-2.9-5.3-5.2-7.4 c-2.4-2.2-5.2-3.9-8.2-5C311.9,49.6,304.2,49.6,297.2,52"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000121989479079079447850000010952705250746732719_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000133526831427349344040000001685388100157195432_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000121989479079079447850000010952705250746732719_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100365853626732922450000005168578135556289460_",
    gradientUnits: "userSpaceOnUse",
    x1: -1046.3484,
    y1: 9.04,
    x2: -1045.3484,
    y2: 9.04,
    gradientTransform: "matrix(20.2763 156.1188 -156.1188 20.2763 22927.248 163179.0781)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25D973"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2FBB82"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000100365853626732922450000005168578135556289460_)"
    },
    points: "276.8,50.9 333.2,43.6  339.6,93.1 283.3,100.5  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000134927997699486675380000015340097225093737890_",
    d: "M296.4,65c0.8-1,1.8-1.9,3-2.5 c1.3-0.8,2.7-1.4,4.2-1.8c1.7-0.5,3.5-0.7,5.3-0.7c1.7,0,3.4,0.2,5,0.6c1.4,0.4,2.8,0.9,4,1.7c1.1,0.7,2,1.5,2.9,2.5 c0.6,0.8,1.1,1.6,1.5,2.6h-27.2C295.3,66.6,295.8,65.7,296.4,65 M303.4,60.3c-1.5,0.4-2.9,1-4.3,1.8c-1.2,0.7-2.2,1.6-3.1,2.6 c-0.8,0.9-1.4,2-1.8,3.2h28.5c-0.4-1.2-1-2.3-1.7-3.3c-0.8-1-1.9-1.9-3-2.6c-1.3-0.8-2.7-1.4-4.1-1.8c-1.7-0.4-3.4-0.6-5.1-0.6 C306.9,59.6,305.1,59.8,303.4,60.3 M298.7,92c-3.2-1-6.2-2.5-8.9-4.6c-2.3-1.8-4.1-4.2-5.4-6.9c-1.2-2.7-1.8-5.6-1.8-8.5 c0-2.8,0.6-5.6,1.7-8.1c1.2-2.6,2.9-4.9,5-6.8c2.3-2.1,5.1-3.7,8-4.7c3.4-1.2,7-1.8,10.7-1.8c3.7-0.1,7.3,0.5,10.8,1.8 c3,1.1,5.8,2.7,8.1,4.9c2.2,2,4,4.5,5.1,7.3c1.2,2.8,1.8,5.9,1.8,9c0,0.4,0,0.8,0,1.3s0,0.9-0.1,1.3h-39.5 c0.5,1.3,1.2,2.5,2.2,3.4c1.1,1.1,2.4,2,3.8,2.7c1.7,0.8,3.4,1.4,5.2,1.8c2.2,0.4,4.4,0.6,6.6,0.6c2.4,0,4.8-0.3,7.2-0.8 c2.3-0.5,4.6-1.1,6.8-1.9l3.5,8c-1.4,0.6-2.8,1.2-4.2,1.7c-1.4,0.5-2.9,0.9-4.4,1.2c-1.6,0.3-3.2,0.6-4.8,0.7 c-1.7,0.2-3.5,0.3-5.2,0.2C306.8,93.8,302.7,93.2,298.7,92 M297.1,51.9c-3,1.1-5.8,2.7-8.1,4.8c-2.2,2-3.9,4.3-5.1,7 c-1.2,2.6-1.8,5.4-1.8,8.3c0,3,0.6,6,1.8,8.7c1.3,2.7,3.1,5.1,5.5,7c2.7,2.1,5.7,3.7,9,4.7c4.1,1.2,8.3,1.8,12.5,1.8 c1.8,0,3.6-0.1,5.3-0.2c1.6-0.2,3.2-0.4,4.8-0.7c1.5-0.3,3-0.7,4.4-1.2c1.4-0.5,2.8-1.1,4.2-1.7l0.4-0.2l-0.2-0.4l-3.5-8 l-0.2-0.4l-0.4,0.1c-2.2,0.8-4.5,1.4-6.8,1.9c-2.3,0.5-4.7,0.7-7.1,0.8c-2.2,0-4.4-0.2-6.5-0.6c-1.8-0.4-3.5-0.9-5.1-1.7 c-1.4-0.7-2.6-1.5-3.6-2.6c-0.8-0.8-1.4-1.7-1.9-2.7h39.2l0-0.4c0.1-0.4,0.1-0.9,0.1-1.3c0-0.5,0-0.9,0-1.3 c0-3.2-0.6-6.3-1.8-9.2c-1.2-2.8-3-5.4-5.2-7.5c-2.4-2.2-5.2-3.9-8.3-5C311.9,49.4,304.2,49.4,297.1,51.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000091696389295213038690000005255034457740516020_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000134927997699486675380000015340097225093737890_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000091696389295213038690000005255034457740516020_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140002041306752637890000007960225035615773584_",
    gradientUnits: "userSpaceOnUse",
    x1: -1046.3484,
    y1: 9.0399,
    x2: -1045.3484,
    y2: 9.0399,
    gradientTransform: "matrix(20.2763 156.1188 -156.1188 20.2763 22927.2383 163179.0625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25D973"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2FBB82"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000140002041306752637890000007960225035615773584_)"
    },
    points: "276.6,50.7 333.4,43.4  339.9,93.3 283,100.7  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000000940545274464738760000008015242341639780286_",
    d: "M359.6,51.2c-2.7,0.7-5.3,1.8-7.7,3.2V51H341v42.1 h10.9V64.9c0.9-0.8,1.8-1.5,2.8-2.1c1-0.6,2.1-1.2,3.3-1.6c1.1-0.4,2.3-0.8,3.5-1c1.1-0.2,2.3-0.3,3.4-0.3c2,0,3.9,0.3,5.8,1 c1.6,0.6,3.1,1.5,4.3,2.8c1.2,1.3,2.2,2.8,2.7,4.5c0.7,2,1,4,1,6.1v19h10.9V72.4c0.1-3.3-0.5-6.5-1.7-9.6c-1-2.7-2.6-5-4.7-7 c-2.1-1.9-4.5-3.3-7.1-4.2c-2.9-1-5.9-1.4-8.9-1.4C364.6,50.2,362.1,50.6,359.6,51.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000088836818695865373220000010820632638477459640_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000000940545274464738760000008015242341639780286_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000088836818695865373220000010820632638477459640_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150812673769050144380000010292769357307335091_",
    gradientUnits: "userSpaceOnUse",
    x1: -1046.3484,
    y1: 9.0322,
    x2: -1045.3484,
    y2: 9.0322,
    gradientTransform: "matrix(20.2763 156.1188 -156.1188 20.2763 22982.125 163171.9688)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25D973"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2FBB82"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000150812673769050144380000010292769357307335091_)"
    },
    points: "335.5,50.9 388.7,44 395,92.4  341.8,99.3  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000073718689580964327970000013321929247991346319_",
    d: "M359.6,51.4c2.4-0.6,4.9-0.9,7.4-1c3,0,6,0.4,8.8,1.4 c2.6,0.9,5,2.3,7,4.2c2,1.9,3.6,4.3,4.6,6.9c1.2,3,1.7,6.3,1.7,9.5v20.5h-10.4V74.1c0-2.1-0.3-4.2-1-6.1 c-0.6-1.7-1.5-3.3-2.8-4.6c-1.2-1.3-2.8-2.2-4.4-2.8c-1.9-0.7-3.8-1-5.8-1c-1.2,0-2.3,0.1-3.5,0.3c-1.2,0.2-2.4,0.6-3.5,1 c-1.2,0.4-2.3,1-3.3,1.6c-1,0.6-2,1.4-2.9,2.2v28.2h-10.4V51.2h10.5v3.5C354.1,53.3,356.8,52.2,359.6,51.4 M359.5,51 c-2.6,0.7-5.1,1.7-7.4,3v-3.2h-11.3v42.6h11.3V65c0.8-0.8,1.7-1.4,2.7-2c1-0.6,2.1-1.2,3.2-1.6c1.1-0.4,2.3-0.8,3.4-1 c1.1-0.2,2.3-0.3,3.4-0.3c1.9,0,3.9,0.3,5.7,1c1.6,0.6,3.1,1.5,4.3,2.7c1.2,1.3,2.1,2.8,2.7,4.4c0.7,1.9,1,4,1,6v19.2h11.3V72.4 c0.1-3.3-0.5-6.6-1.7-9.7c-1.1-2.7-2.7-5-4.8-7c-2.1-1.9-4.6-3.4-7.2-4.3c-2.9-1-5.9-1.4-9-1.4C364.5,50.1,361.9,50.4,359.5,51"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000053535640078227104360000001301224382104600979_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000073718689580964327970000013321929247991346319_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000053535640078227104360000001301224382104600979_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084532080399938444230000005144273563974423215_",
    gradientUnits: "userSpaceOnUse",
    x1: -1046.3484,
    y1: 9.0323,
    x2: -1045.3484,
    y2: 9.0323,
    gradientTransform: "matrix(20.2763 156.1188 -156.1188 20.2763 22982.1465 163172)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25D973"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2FBB82"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000084532080399938444230000005144273563974423215_)"
    },
    points: "335.2,50.7 388.9,43.8  395.2,92.6 341.6,99.6  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000173147729719658945370000000022327334810974117_",
    d: "M184.7,102.9c-3.8,1.3-7.4,3.3-10.4,5.9 c-2.8,2.5-5,5.5-6.5,8.9c-1.5,3.5-2.2,7.2-2.2,11c0,3.9,0.7,7.7,2.3,11.3c1.5,3.5,3.7,6.7,6.5,9.3c3,2.7,6.6,4.9,10.4,6.2 c4.5,1.6,9.2,2.3,13.9,2.3c3.4,0,6.9-0.4,10.2-1.2c2.9-0.7,5.7-1.8,8.3-3.4c2.4-1.4,4.5-3.1,6.3-5.1c1.7-2,3.1-4.2,4.2-6.6 c1-2.4,1.6-5,1.9-7.6c0.2-2.8,0-5.6-0.6-8.3v-0.2h-29.8v9.7h19.3c-0.3,1.8-1,3.5-2,5c-1.1,1.6-2.4,2.9-4,4 c-1.8,1.2-3.7,2-5.7,2.5c-5.4,1.3-11,1.2-16.3-0.5c-2.5-0.8-4.8-2.1-6.9-3.8c-1.9-1.6-3.4-3.6-4.4-5.8c-1-2.4-1.5-4.9-1.5-7.5 c0-2.5,0.5-4.9,1.5-7.2c1-2.2,2.4-4.1,4.3-5.6c2-1.7,4.4-2.9,6.9-3.7c3-0.9,6.1-1.4,9.3-1.3c1.5,0,3,0.1,4.5,0.2 c1.5,0.2,2.9,0.4,4.3,0.7c1.3,0.3,2.6,0.7,3.9,1.2c1.1,0.4,2.2,0.9,3.2,1.5l0.2,0.1l5.4-8.9l-0.2-0.1c-1.6-0.9-3.3-1.7-5.1-2.3 c-1.8-0.7-3.6-1.2-5.5-1.6c-1.9-0.4-3.8-0.7-5.7-0.9c-1.9-0.2-3.8-0.3-5.8-0.3C194,100.7,189.2,101.4,184.7,102.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000082330040964081727230000009418385739148130432_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173147729719658945370000000022327334810974117_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000082330040964081727230000009418385739148130432_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022558857586925810290000016280003057284146081_",
    gradientUnits: "userSpaceOnUse",
    x1: -1046.3484,
    y1: 9.0393,
    x2: -1045.3484,
    y2: 9.0393,
    gradientTransform: "matrix(20.2763 156.1188 -156.1188 20.2763 22811.1406 163194.2188)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25D973"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2FBB82"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000022558857586925810290000016280003057284146081_)"
    },
    points: "158.3,101.7 228.7,92.6  237.1,156.9 166.7,166.1  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000170958758696735797720000013060333714952653991_",
    d: "M184.9,155.4c-3.8-1.4-7.3-3.5-10.3-6.2 c-2.8-2.6-5-5.7-6.5-9.2c-1.5-3.6-2.3-7.4-2.2-11.2c0-3.7,0.7-7.5,2.2-10.9c1.5-3.4,3.6-6.4,6.4-8.8c3-2.6,6.5-4.6,10.3-5.9 c4.5-1.5,9.3-2.2,14.1-2.1c1.9,0,3.8,0.1,5.7,0.3c1.9,0.2,3.8,0.5,5.7,0.9c1.9,0.4,3.7,1,5.5,1.6c1.7,0.6,3.4,1.4,5.1,2.3 l-5.2,8.5c-1.1-0.6-2.2-1.1-3.3-1.5c-1.3-0.5-2.6-0.9-3.9-1.2c-1.4-0.3-2.9-0.6-4.4-0.7c-1.5-0.2-3-0.3-4.5-0.2 c-3.2,0-6.3,0.4-9.3,1.3c-2.5,0.8-4.9,2-6.9,3.7c-1.8,1.5-3.3,3.5-4.3,5.7c-1,2.3-1.5,4.8-1.5,7.3c0,2.6,0.5,5.2,1.6,7.5 c1,2.3,2.5,4.3,4.4,5.9c2,1.7,4.4,3,6.9,3.9c5.3,1.7,11,1.8,16.4,0.5c2.1-0.5,4-1.4,5.8-2.6c1.6-1.1,2.9-2.4,4-4 c1.1-1.6,1.8-3.4,2.1-5.3h-19.3v-9.3h29.4h-5.9h6c0.6,2.7,0.8,5.5,0.5,8.3c-0.2,2.6-0.8,5.2-1.8,7.6c-1,2.4-2.4,4.6-4.1,6.5 c-1.8,2-3.9,3.7-6.3,5.1c-2.6,1.5-5.4,2.6-8.3,3.3c-3.3,0.8-6.7,1.2-10.1,1.2C194,157.7,189.4,157,184.9,155.4 M184.7,102.7 c-3.9,1.3-7.4,3.3-10.5,6c-2.8,2.5-5,5.6-6.5,9c-1.5,3.5-2.3,7.3-2.2,11.1c0,3.9,0.8,7.8,2.3,11.4c1.5,3.5,3.8,6.7,6.6,9.3 c3.1,2.8,6.6,4.9,10.5,6.3c4.5,1.6,9.2,2.4,13.9,2.3c3.5,0,6.9-0.4,10.3-1.2c2.9-0.7,5.8-1.9,8.4-3.4c2.4-1.4,4.5-3.1,6.4-5.2 c1.7-2,3.2-4.2,4.2-6.6c1-2.5,1.7-5.1,1.9-7.7c0.2-2.8,0-5.6-0.6-8.4l-0.1-0.3H199v10.1h19.2c-0.3,1.6-1,3.2-1.9,4.6 c-1,1.5-2.4,2.9-3.9,3.9c-1.7,1.1-3.7,2-5.7,2.5c-5.3,1.3-10.9,1.2-16.2-0.5c-2.5-0.8-4.8-2.1-6.8-3.8c-1.8-1.6-3.3-3.5-4.3-5.8 c-1-2.3-1.5-4.8-1.5-7.4c0-2.4,0.5-4.9,1.4-7.1c1-2.1,2.4-4.1,4.2-5.6c2-1.6,4.3-2.9,6.8-3.6c3-0.9,6.1-1.3,9.2-1.3 c1.5,0,3,0.1,4.5,0.2c1.4,0.2,2.9,0.4,4.3,0.7c1.3,0.3,2.6,0.7,3.9,1.2c1.1,0.4,2.2,0.9,3.2,1.5l0.4,0.2l0.2-0.4l5.2-8.5 l0.2-0.4l-0.4-0.2c-1.6-0.9-3.4-1.7-5.1-2.3c-1.8-0.7-3.7-1.2-5.5-1.6c-1.9-0.4-3.8-0.7-5.7-0.9c-1.9-0.2-3.9-0.3-5.8-0.3 C194,100.5,189.2,101.2,184.7,102.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000066510303017526953340000008944618422174549433_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000170958758696735797720000013060333714952653991_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000066510303017526953340000008944618422174549433_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147203762782112301050000000969910763206162057_",
    gradientUnits: "userSpaceOnUse",
    x1: -1046.3385,
    y1: 9.0372,
    x2: -1045.3385,
    y2: 9.0372,
    gradientTransform: "matrix(20.4659 155.8557 -155.8557 20.4659 23006.3223 162915.4531)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25D973"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2FBB82"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000147203762782112301050000000969910763206162057_)"
    },
    points: "157.9,101.1 228.6,91.9  237.1,156.6 166.4,165.9  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000132801289807398705060000001995375126308581007_",
    d: "M266.3,114.1c-3.6,0.2-7.2,1-10.6,2.4 c-2.5,1.1-4.8,2.5-7,4.2V115h-10.9v42.2h10.9v-25c1.9-2.5,4.4-4.5,7.3-5.8c3.3-1.5,6.7-2.4,10.3-2.7h0.2v-9.5L266.3,114.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052785387139897829320000017570258239411022213_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132801289807398705060000001995375126308581007_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000052785387139897829320000017570258239411022213_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024694679468710582750000013906878821296742834_",
    gradientUnits: "userSpaceOnUse",
    x1: -1046.3484,
    y1: 9.0405,
    x2: -1045.3484,
    y2: 9.0405,
    gradientTransform: "matrix(20.2763 156.1188 -156.1188 20.2763 22864.0566 163187.2969)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25D973"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2FBB82"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000024694679468710582750000013906878821296742834_)"
    },
    points: "232.3,114.8 266,110.4  272,156.4 238.3,160.8  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000145749863959600932120000015610139391170538113_",
    d: "M255.8,116.8c3.3-1.4,6.9-2.2,10.5-2.4v9.1 c-3.6,0.3-7.1,1.2-10.4,2.7c-2.9,1.3-5.5,3.3-7.4,5.9v24.8H238v-41.7h10.5v6C250.7,119.4,253.2,117.9,255.8,116.8 M266.3,113.9 c-3.7,0.2-7.3,1-10.7,2.4c-2.4,1.1-4.7,2.4-6.7,4v-5.6h-11.3v42.6h11.3v-25.1c1.9-2.5,4.4-4.4,7.2-5.7c3.2-1.5,6.7-2.4,10.2-2.7 h0.4v-0.4v-9.1v-0.4L266.3,113.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000089559910336172610630000006052408913485848720_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000145749863959600932120000015610139391170538113_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000089559910336172610630000006052408913485848720_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018228340264675984470000000172236597070495892_",
    gradientUnits: "userSpaceOnUse",
    x1: -1046.3484,
    y1: 9.0403,
    x2: -1045.3484,
    y2: 9.0403,
    gradientTransform: "matrix(20.2763 156.1188 -156.1188 20.2763 22864.0293 163187.2656)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25D973"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2FBB82"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000018228340264675984470000000172236597070495892_)"
    },
    points: "232,114.6 266.2,110.1  272.3,156.6 238,161  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000042007347894076666550000003900031707688238464_",
    d: "M284,128.8c0.9-1,1.9-1.9,3-2.6 c1.3-0.8,2.7-1.4,4.2-1.8c1.7-0.5,3.6-0.7,5.4-0.7c1.7,0,3.4,0.2,5.1,0.6c1.4,0.4,2.8,1,4,1.7c1.1,0.7,2.1,1.6,2.9,2.6 c0.7,0.9,1.2,1.8,1.6,2.9h-27.8C282.7,130.6,283.3,129.7,284,128.8 M285,116c-2.9,1.1-5.7,2.7-8,4.8c-2.1,1.9-3.8,4.3-5,6.9 c-1.2,2.6-1.8,5.4-1.8,8.2c0,3,0.6,5.9,1.8,8.6c1.2,2.7,3.1,5.1,5.4,7c2.7,2.1,5.7,3.7,8.9,4.7c4,1.2,8.2,1.8,12.4,1.7 c1.8,0,3.6-0.1,5.3-0.2c1.6-0.2,3.2-0.4,4.8-0.7c1.5-0.3,3-0.7,4.4-1.2c1.4-0.5,2.8-1.1,4.2-1.7l0.2-0.1l-3.7-8.4l-0.2,0.1 c-2.2,0.8-4.5,1.4-6.8,1.9c-2.3,0.5-4.7,0.7-7.1,0.8c-2.2,0-4.4-0.2-6.5-0.6c-1.8-0.4-3.5-0.9-5.2-1.7c-1.4-0.7-2.6-1.6-3.7-2.6 c-0.9-0.9-1.5-1.9-2-3.1h39.4v-0.2c0.1-0.4,0.1-0.9,0.1-1.3c0-0.5,0-0.9,0-1.3c0-3.1-0.6-6.2-1.8-9.1c-1.2-2.8-2.9-5.3-5.2-7.4 c-2.4-2.2-5.2-3.9-8.2-4.9C299.7,113.6,292,113.6,285,116"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085248700935059241360000011954951125834815642_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000042007347894076666550000003900031707688238464_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000085248700935059241360000011954951125834815642_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036972300796946270580000012806883271094596497_",
    gradientUnits: "userSpaceOnUse",
    x1: -1046.3484,
    y1: 9.0398,
    x2: -1045.3484,
    y2: 9.0398,
    gradientTransform: "matrix(20.2763 156.1188 -156.1188 20.2763 22907.0352 163181.6719)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25D973"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2FBB82"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000036972300796946270580000012806883271094596497_)"
    },
    points: "264.6,114.9 321,107.6  327.4,157.1 271,164.5  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000106836093586588427860000018001038475669230522_",
    d: "M284.2,129c0.8-1,1.8-1.8,3-2.5 c1.3-0.8,2.7-1.4,4.2-1.8c1.7-0.4,3.5-0.7,5.3-0.7c1.7,0,3.4,0.2,5,0.6c1.4,0.4,2.8,0.9,4,1.7c1.1,0.7,2.1,1.5,2.9,2.5 c0.6,0.8,1.1,1.6,1.5,2.6h-27.2C283,130.6,283.6,129.7,284.2,129 M291.2,124.3c-1.5,0.4-2.9,1-4.3,1.8c-1.2,0.7-2.2,1.6-3.1,2.6 c-0.8,0.9-1.4,2-1.8,3.1h28.5c-0.4-1.2-1-2.3-1.8-3.2c-0.8-1-1.8-1.9-3-2.6c-1.3-0.8-2.7-1.4-4.1-1.8c-1.7-0.4-3.4-0.7-5.1-0.6 C294.8,123.6,292.9,123.9,291.2,124.3 M286.4,156c-3.2-1-6.2-2.5-8.9-4.6c-2.3-1.9-4.1-4.2-5.4-6.9c-1.2-2.7-1.8-5.6-1.8-8.5 c0-2.8,0.6-5.6,1.7-8.1c1.2-2.6,2.9-4.9,5-6.8c2.3-2.1,5.1-3.7,8-4.7c3.4-1.2,7.1-1.8,10.7-1.8c3.7-0.1,7.3,0.6,10.8,1.8 c3,1.1,5.8,2.7,8.1,4.9c2.2,2,4,4.5,5.1,7.3c1.2,2.8,1.8,5.9,1.8,9c0,0.4,0,0.8,0,1.3s0,0.9-0.1,1.3H282 c0.5,1.3,1.2,2.5,2.2,3.4c1.1,1.1,2.4,2,3.8,2.7c1.7,0.8,3.4,1.4,5.2,1.8c2.2,0.4,4.4,0.6,6.6,0.6c2.4,0,4.8-0.3,7.2-0.8 c2.3-0.5,4.6-1.1,6.8-1.9l3.5,8c-1.4,0.6-2.7,1.2-4.1,1.7c-1.4,0.5-2.9,0.9-4.4,1.2c-1.6,0.3-3.2,0.6-4.8,0.7 c-1.7,0.2-3.4,0.2-5.2,0.2C294.6,157.8,290.4,157.2,286.4,156 M284.9,115.9c-3,1.1-5.7,2.7-8.1,4.8c-2.2,2-3.9,4.3-5.1,7 c-1.2,2.6-1.8,5.4-1.8,8.3c0,3,0.6,6,1.8,8.7c1.3,2.7,3.1,5.1,5.5,7c2.7,2.1,5.7,3.7,9,4.7c4,1.2,8.2,1.8,12.5,1.7 c1.8,0,3.5-0.1,5.3-0.2c1.6-0.2,3.2-0.4,4.8-0.7c1.5-0.3,3-0.7,4.4-1.2c1.4-0.5,2.8-1.1,4.2-1.7l0.4-0.2l-0.2-0.4l-3.5-8 l-0.2-0.4l-0.4,0.1c-2.2,0.8-4.5,1.4-6.8,1.9c-2.3,0.5-4.7,0.7-7.1,0.8c-2.2,0-4.4-0.2-6.5-0.6c-1.8-0.3-3.5-0.9-5.1-1.7 c-1.4-0.7-2.6-1.5-3.6-2.6c-0.8-0.8-1.4-1.7-1.9-2.7h39.2l0-0.4c0.1-0.4,0.1-0.9,0.1-1.3c0-0.5,0-0.9,0-1.3 c0-3.2-0.6-6.3-1.8-9.2c-1.2-2.8-3-5.4-5.2-7.5c-2.4-2.2-5.2-3.9-8.3-5C299.6,113.4,292,113.4,284.9,115.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127035156021435696110000001200271988275402125_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106836093586588427860000018001038475669230522_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000127035156021435696110000001200271988275402125_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046316346029033999860000013014479074536275887_",
    gradientUnits: "userSpaceOnUse",
    x1: -1046.3484,
    y1: 9.04,
    x2: -1045.3484,
    y2: 9.04,
    gradientTransform: "matrix(20.2763 156.1188 -156.1188 20.2763 22907.0645 163181.7188)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25D973"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2FBB82"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000046316346029033999860000013014479074536275887_)"
    },
    points: "264.3,114.7 321.2,107.4  327.7,157.3 270.8,164.7  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000116933368548437360110000009207621479679343796_",
    d: "M342.6,128.8c0.9-1,1.9-1.9,3-2.6 c1.3-0.8,2.7-1.4,4.2-1.8c1.7-0.5,3.6-0.7,5.4-0.7c1.7,0,3.4,0.2,5.1,0.6c1.4,0.4,2.8,1,4,1.7c1.1,0.7,2.1,1.6,2.9,2.6 c0.7,0.9,1.2,1.8,1.6,2.9H341C341.4,130.6,341.9,129.7,342.6,128.8 M343.6,116c-2.9,1.1-5.7,2.7-8,4.8c-2.1,1.9-3.8,4.3-5,6.9 c-1.2,2.6-1.8,5.4-1.8,8.2c0,3,0.6,5.9,1.8,8.6c1.2,2.7,3.1,5.1,5.4,7c2.7,2.1,5.7,3.7,8.9,4.7c4,1.2,8.2,1.8,12.4,1.7 c1.8,0,3.6-0.1,5.3-0.2c1.6-0.2,3.2-0.4,4.8-0.7c1.5-0.3,3-0.7,4.4-1.2c1.4-0.5,2.8-1.1,4.2-1.7l0.2-0.1l-3.7-8.4l-0.2,0.1 c-2.2,0.8-4.5,1.4-6.8,1.9c-2.3,0.5-4.7,0.7-7.1,0.8c-2.2,0-4.4-0.2-6.5-0.6c-1.8-0.4-3.5-0.9-5.2-1.7c-1.4-0.7-2.7-1.6-3.8-2.7 c-0.9-0.9-1.5-1.9-2-3.1h39.4v-0.2c0.1-0.4,0.1-0.9,0.1-1.3c0-0.5,0-0.9,0-1.3c0-3.1-0.6-6.2-1.8-9.1c-1.2-2.8-2.9-5.3-5.2-7.4 c-2.4-2.2-5.2-3.9-8.2-4.9C358.2,113.7,350.6,113.7,343.6,116"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083810165328959361510000004587266497000222637_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116933368548437360110000009207621479679343796_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000083810165328959361510000004587266497000222637_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039129752970948898900000010069536093551471763_",
    gradientUnits: "userSpaceOnUse",
    x1: -1046.3484,
    y1: 9.0401,
    x2: -1045.3484,
    y2: 9.0401,
    gradientTransform: "matrix(20.2763 156.1188 -156.1188 20.2763 22964.7422 163174.2812)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25D973"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2FBB82"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000039129752970948898900000010069536093551471763_)"
    },
    points: "323.2,114.9 379.6,107.6  386,157.1 329.7,164.5  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000124139548246627521960000004266477871451710088_",
    d: "M342.8,129c0.8-1,1.8-1.8,3-2.5 c1.3-0.8,2.7-1.4,4.2-1.8c1.7-0.4,3.5-0.7,5.3-0.7c1.7,0,3.4,0.2,5,0.6c1.4,0.4,2.8,0.9,4,1.7c1.1,0.7,2.1,1.5,2.9,2.5 c0.6,0.8,1.1,1.6,1.5,2.6h-27.2C341.7,130.6,342.2,129.7,342.8,129 M349.8,124.3c-1.5,0.4-2.9,1-4.3,1.8 c-1.2,0.7-2.2,1.6-3.1,2.6c-0.8,0.9-1.4,2-1.8,3.1h28.5c-0.4-1.2-1-2.3-1.8-3.2c-0.8-1-1.8-1.9-3-2.6c-1.3-0.8-2.7-1.4-4.1-1.8 c-1.7-0.4-3.4-0.7-5.1-0.6C353.4,123.6,351.6,123.9,349.8,124.3 M345.1,156c-3.2-1-6.2-2.5-8.9-4.6c-2.3-1.9-4.1-4.2-5.4-6.9 c-1.2-2.7-1.8-5.6-1.8-8.5c0-2.8,0.6-5.6,1.7-8.1c1.2-2.6,2.9-4.9,5-6.8c2.3-2.1,5.1-3.7,8-4.7c3.4-1.2,7.1-1.8,10.7-1.8 c3.7-0.1,7.3,0.6,10.8,1.8c3,1.1,5.8,2.7,8.1,4.9c2.2,2,4,4.5,5.1,7.3c1.2,2.8,1.8,5.9,1.8,9c0,0.4,0,0.8,0,1.3 c0,0.4,0,0.8-0.1,1.3h-39.5c0.5,1.3,1.2,2.5,2.2,3.4c1.1,1.1,2.4,2,3.8,2.7c1.7,0.8,3.4,1.4,5.2,1.8c2.2,0.4,4.4,0.6,6.6,0.6 c2.4,0,4.8-0.3,7.2-0.8c2.3-0.5,4.6-1.1,6.8-1.9l3.5,8c-1.4,0.6-2.7,1.2-4.2,1.7c-1.4,0.5-2.9,0.9-4.4,1.2 c-1.6,0.3-3.2,0.6-4.8,0.7c-1.7,0.2-3.4,0.2-5.2,0.2C353.2,157.8,349.1,157.2,345.1,156 M343.5,115.9c-3,1.1-5.7,2.7-8.1,4.8 c-2.2,2-3.9,4.3-5.1,7c-1.2,2.6-1.8,5.4-1.8,8.3c0,3,0.6,6,1.8,8.7c1.3,2.7,3.1,5.1,5.5,7c2.7,2.1,5.7,3.7,9,4.7 c4,1.2,8.2,1.8,12.5,1.7c1.8,0,3.5-0.1,5.3-0.2c1.6-0.2,3.2-0.4,4.8-0.7c1.5-0.3,3-0.7,4.4-1.2c1.4-0.5,2.8-1.1,4.2-1.7l0.4-0.2 l-0.2-0.4l-3.5-8l-0.2-0.4l-0.4,0.1c-2.2,0.8-4.5,1.4-6.8,1.9c-2.3,0.5-4.7,0.7-7.1,0.8c-2.2,0-4.4-0.2-6.5-0.6 c-1.8-0.3-3.5-0.9-5.1-1.7c-1.4-0.7-2.6-1.5-3.6-2.6c-0.8-0.8-1.4-1.7-1.9-2.7h39.2l0-0.4c0.1-0.4,0.1-0.9,0.1-1.3 c0-0.5,0-0.9,0-1.3c0-3.2-0.6-6.3-1.8-9.2c-1.2-2.8-3-5.4-5.2-7.5c-2.4-2.2-5.2-3.9-8.3-5C358.2,113.4,350.6,113.4,343.5,115.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000108279877018178738600000015453151716282576796_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000124139548246627521960000004266477871451710088_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000108279877018178738600000015453151716282576796_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098917636954954426840000017781116827674907788_",
    gradientUnits: "userSpaceOnUse",
    x1: -1046.3484,
    y1: 9.0402,
    x2: -1045.3484,
    y2: 9.0402,
    gradientTransform: "matrix(20.2763 156.1188 -156.1188 20.2763 22964.7734 163174.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25D973"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2FBB82"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000098917636954954426840000017781116827674907788_)"
    },
    points: "323,114.7 379.8,107.4  386.3,157.3 329.5,164.7  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000149374458167634920570000014940838004724294546_",
    d: "M406.2,115.2c-2.7,0.7-5.3,1.8-7.7,3.2V115h-10.9v42.2 h10.9v-28.3c0.9-0.8,1.8-1.5,2.8-2.1c1-0.6,2.1-1.2,3.3-1.6c1.1-0.4,2.3-0.8,3.5-1c1.1-0.2,2.3-0.3,3.4-0.3c2,0,3.9,0.3,5.8,1 c1.6,0.6,3.1,1.5,4.3,2.8c1.2,1.3,2.2,2.8,2.7,4.5c0.7,1.9,1,4,1,6.1v19h10.9v-20.7c0.1-3.3-0.5-6.5-1.7-9.6c-1-2.7-2.6-5-4.7-7 c-2-1.9-4.5-3.3-7.1-4.2c-2.9-1-5.9-1.4-8.9-1.4C411.2,114.2,408.7,114.6,406.2,115.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085244309468360067120000009311126136703675067_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000149374458167634920570000014940838004724294546_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000085244309468360067120000009311126136703675067_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111884222821820339970000009356214389183304331_",
    gradientUnits: "userSpaceOnUse",
    x1: -1046.3484,
    y1: 9.0322,
    x2: -1045.3484,
    y2: 9.0322,
    gradientTransform: "matrix(20.2763 156.1188 -156.1188 20.2763 23019.8477 163167.0781)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25D973"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2FBB82"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000111884222821820339970000009356214389183304331_)"
    },
    points: "382.1,114.9 435.3,108  441.6,156.4 388.4,163.3  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000150806955117586771470000006101186524468102542_",
    d: "M406.3,115.4c2.4-0.6,4.9-1,7.4-1c3,0,6,0.4,8.8,1.4 c2.6,0.9,5,2.3,7,4.2c2,1.9,3.6,4.3,4.6,6.9c1.2,3,1.7,6.3,1.7,9.5v20.5h-10.4v-18.8c0-2.1-0.3-4.2-1-6.1 c-0.6-1.7-1.5-3.3-2.8-4.6c-1.2-1.3-2.8-2.2-4.4-2.8c-1.9-0.7-3.8-1-5.8-1c-1.2,0-2.3,0.2-3.5,0.4c-1.2,0.2-2.4,0.6-3.5,1 c-1.2,0.4-2.3,1-3.3,1.6c-1,0.6-2,1.4-2.9,2.2V157h-10.5v-41.8h10.5v3.5C400.8,117.3,403.5,116.2,406.3,115.4 M406.2,115 c-2.6,0.7-5.1,1.7-7.4,3v-3.2h-11.3v42.6h11.3V129c0.8-0.8,1.7-1.4,2.7-2c1-0.6,2.1-1.2,3.2-1.6c1.1-0.4,2.3-0.8,3.4-1 c1.1-0.2,2.3-0.3,3.4-0.3c1.9,0,3.9,0.3,5.7,0.9c1.6,0.6,3.1,1.5,4.3,2.7c1.2,1.3,2.1,2.8,2.7,4.4c0.7,1.9,1,4,1,6v19.2h11.3 v-21c0.1-3.3-0.5-6.6-1.7-9.7c-1.1-2.7-2.7-5-4.8-7c-2.1-1.9-4.5-3.4-7.2-4.2c-2.9-1-5.9-1.5-9-1.4 C411.1,114.1,408.6,114.4,406.2,115"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000056394386844787271090000016667025850927300021_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150806955117586771470000006101186524468102542_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000056394386844787271090000016667025850927300021_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093170152148010478310000010721721195680226478_",
    gradientUnits: "userSpaceOnUse",
    x1: -1046.3385,
    y1: 9.0298,
    x2: -1045.3385,
    y2: 9.0298,
    gradientTransform: "matrix(20.4659 155.8557 -155.8557 20.4659 23214.582 162888.0312)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25D973"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2FBB82"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000093170152148010478310000010721721195680226478_)"
    },
    points: "381.4,114.1 434.9,107  441.3,155.8 387.8,162.8  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000127039307711911799130000013349239095377420479_",
    points: "168.6,165.8 168.6,170.2 177.7,170.2  177.7,190.5 182.8,190.5 182.8,170.2 191.9,170.2 191.9,165.8  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000027596810637964981740000014231362483584314249_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127039307711911799130000013349239095377420479_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000027596810637964981740000014231362483584314249_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137124344216690564190000008305624870503940022_",
    gradientUnits: "userSpaceOnUse",
    x1: -1040.6586,
    y1: -0.1344,
    x2: -1039.6586,
    y2: -0.1344,
    gradientTransform: "matrix(4.5006 48.7929 -48.7929 4.5006 4855.3823 50934.8984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3FA9F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D76C9"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000137124344216690564190000008305624870503940022_)"
    },
    points: "166.3,166 191.7,163.7  194.1,190.3 168.8,192.6  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000155148814972325311670000010912421397638577081_",
    d: "M197.1,177.9c0.4-0.5,0.9-0.9,1.4-1.2 c0.6-0.4,1.2-0.6,1.9-0.8c0.8-0.2,1.6-0.3,2.4-0.3c0.8,0,1.5,0.1,2.3,0.3c0.6,0.2,1.3,0.4,1.8,0.8c0.5,0.3,1,0.7,1.3,1.2 c0.3,0.4,0.6,0.9,0.8,1.4h-12.7C196.5,178.8,196.8,178.3,197.1,177.9 M197.7,172.3c-1.3,0.5-2.5,1.2-3.6,2.1 c-1,0.9-1.7,1.9-2.2,3.1c-0.5,1.1-0.8,2.4-0.8,3.6c0,1.3,0.3,2.6,0.8,3.8c0.6,1.2,1.4,2.3,2.4,3.1c1.2,0.9,2.5,1.6,4,2.1 c1.8,0.5,3.7,0.8,5.5,0.8c0.8,0,1.6,0,2.4-0.1s1.5-0.2,2.1-0.3c0.7-0.1,1.3-0.3,2-0.5c0.6-0.2,1.3-0.5,1.9-0.8l-1.6-3.6 c-1,0.4-2,0.6-3.1,0.9c-1.1,0.2-2.1,0.3-3.2,0.3c-1,0-2-0.1-2.9-0.3c-0.8-0.2-1.6-0.4-2.3-0.8c-0.6-0.3-1.2-0.7-1.7-1.2 c-0.4-0.4-0.8-1-1-1.5H214c0-0.2,0-0.4,0-0.6c0-0.2,0-0.4,0-0.6c0-1.4-0.3-2.7-0.8-4c-0.5-1.2-1.3-2.4-2.3-3.3 c-1.1-1-2.3-1.7-3.6-2.2C204.2,171.3,200.8,171.3,197.7,172.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000167373157185388107450000005250224921563830705_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155148814972325311670000010912421397638577081_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000167373157185388107450000005250224921563830705_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175305217302667207290000012322027699892285582_",
    gradientUnits: "userSpaceOnUse",
    x1: -1040.6586,
    y1: -0.1538,
    x2: -1039.6586,
    y2: -0.1538,
    gradientTransform: "matrix(4.5006 48.7929 -48.7929 4.5006 4876.2881 50932.9844)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3FA9F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D76C9"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000175305217302667207290000012322027699892285582_)"
    },
    points: "189.3,171.7 213.8,169.4  215.8,190.7 191.3,192.9  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000168804917686096026100000000528108631615983039_",
    d: "M223.9,172.2c-1.3,0.4-2.5,1.1-3.6,2.1 c-0.9,0.9-1.7,1.9-2.2,3.1c-0.5,1.2-0.8,2.5-0.8,3.8c0,1.3,0.3,2.6,0.8,3.8c0.5,1.2,1.3,2.2,2.2,3c1.1,0.9,2.3,1.6,3.6,2 c1.5,0.5,3.2,0.8,4.8,0.7c0.9,0,1.7-0.1,2.5-0.2c0.8-0.1,1.6-0.3,2.3-0.5c0.7-0.2,1.4-0.5,2.1-0.8c0.6-0.3,1.2-0.6,1.8-0.9 l-2.2-3.5c-0.9,0.5-1.9,1-2.9,1.3c-1.1,0.3-2.2,0.5-3.3,0.5c-1,0-1.9-0.1-2.9-0.4c-0.8-0.2-1.5-0.6-2.2-1.2 c-1.2-1-1.9-2.4-1.9-4c0-0.8,0.2-1.5,0.5-2.2c0.3-0.7,0.8-1.3,1.4-1.8c0.6-0.5,1.4-0.9,2.2-1.2c0.9-0.3,1.9-0.4,2.9-0.4 c0.9,0,1.9,0.1,2.8,0.3c1,0.2,2,0.6,2.9,1l2.2-3.5c-0.5-0.3-1.1-0.6-1.7-0.8c-0.7-0.2-1.4-0.5-2.1-0.6c-0.8-0.2-1.5-0.3-2.3-0.4 c-0.8-0.1-1.6-0.1-2.4-0.1c-1.6,0-3.2,0.2-4.8,0.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000154424168726431188320000005707164258273047992_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000168804917686096026100000000528108631615983039_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000154424168726431188320000005707164258273047992_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083055071598456227510000007791466525287797646_",
    gradientUnits: "userSpaceOnUse",
    x1: -1040.6586,
    y1: -0.1522,
    x2: -1039.6586,
    y2: -0.1522,
    gradientTransform: "matrix(4.5006 48.7929 -48.7929 4.5006 4901.1196 50930.6953)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3FA9F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D76C9"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000083055071598456227510000007791466525287797646_)"
    },
    points: "215.6,171.7 237.5,169.7  239.4,190.7 217.6,192.7  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000050663095437075521030000009066545472548446357_",
    d: "M241.8,164.3v26.2h4.7v-12.9c0.8-0.6,1.7-1.1,2.7-1.4 c1.1-0.4,2.2-0.6,3.3-0.6c0.9,0,1.8,0.1,2.7,0.4c0.7,0.3,1.4,0.7,2,1.2c0.5,0.5,1,1.2,1.2,1.9c0.3,0.8,0.4,1.6,0.4,2.4v9h4.7 v-9.2c0-1.4-0.2-2.8-0.7-4.1c-0.4-1.2-1.1-2.2-2-3.1c-0.9-0.9-1.9-1.6-3.1-2c-1.3-0.5-2.7-0.7-4.2-0.7c-2.5,0-4.9,0.6-7.1,1.8 v-9L241.8,164.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036947509433966037670000003023619269001089666_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000050663095437075521030000009066545472548446357_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000036947509433966037670000003023619269001089666_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124126807124965754640000016530966751801406883_",
    gradientUnits: "userSpaceOnUse",
    x1: -1040.6586,
    y1: -0.1691,
    x2: -1039.6586,
    y2: -0.1691,
    gradientTransform: "matrix(4.5006 48.7929 -48.7929 4.5006 4925.5103 50928.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3FA9F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D76C9"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000124126807124965754640000016530966751801406883_)"
    },
    points: "239.4,164.5 263.3,162.3  265.9,190.3 241.9,192.5  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000150800396618460014360000008177675596333383871_",
    d: "M275.1,171.9c-1.3,0.3-2.5,0.8-3.6,1.5v-1.6h-4.7v18.7 h4.7v-12.6c0.4-0.4,0.8-0.7,1.3-1c0.5-0.3,1-0.5,1.5-0.7c0.5-0.2,1-0.3,1.6-0.4c0.5-0.1,1-0.2,1.6-0.2c0.9,0,1.8,0.1,2.6,0.4 c0.8,0.3,1.4,0.7,2,1.3c0.6,0.6,1,1.3,1.2,2c0.3,0.9,0.5,1.8,0.4,2.8v8.4h4.7v-9.2c0-1.5-0.2-2.9-0.8-4.3 c-0.5-1.2-1.2-2.2-2.1-3.1c-0.9-0.8-2-1.5-3.1-1.9c-1.3-0.4-2.6-0.6-4-0.6C277.3,171.4,276.2,171.6,275.1,171.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000090973544669678203360000004261600536098600067_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150800396618460014360000008177675596333383871_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000090973544669678203360000004261600536098600067_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039132912023174764270000001199810314868295590_",
    gradientUnits: "userSpaceOnUse",
    x1: -1040.6586,
    y1: -0.1614,
    x2: -1039.6586,
    y2: -0.1614,
    gradientTransform: "matrix(4.5006 48.7929 -48.7929 4.5006 4950.3428 50926.2031)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3FA9F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D76C9"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000039132912023174764270000001199810314868295590_)"
    },
    points: "265.1,171.7 288.2,169.5  290.1,190.3 267,192.5  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000157266947078280861310000000831918474424425405_",
    d: "M300.5,186.3c-0.8-0.3-1.5-0.7-2.1-1.2 c-1.7-1.5-2.2-3.9-1.3-6c0.3-0.7,0.8-1.3,1.3-1.8c0.6-0.5,1.3-1,2.1-1.2c1.8-0.6,3.8-0.6,5.6,0c0.8,0.3,1.5,0.7,2.1,1.2 c0.6,0.5,1,1.1,1.3,1.8c0.9,2.1,0.4,4.5-1.3,6c-0.6,0.5-1.3,0.9-2.1,1.2C304.3,186.9,302.3,186.9,300.5,186.3 M298.5,172.3 c-1.3,0.4-2.6,1.2-3.7,2.1c-1,0.8-1.8,1.9-2.3,3.1c-1.1,2.4-1.1,5.1,0,7.5c0.5,1.2,1.3,2.2,2.3,3.1c1.1,0.9,2.3,1.6,3.7,2.1 c3.1,1,6.5,1,9.6,0c1.3-0.5,2.6-1.2,3.6-2.1c1-0.8,1.8-1.9,2.3-3.1c1.1-2.4,1.1-5.1,0-7.5c-0.5-1.2-1.3-2.2-2.3-3.1 c-1.1-0.9-2.3-1.6-3.6-2.1C305,171.3,301.6,171.3,298.5,172.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000051383193763860147700000002542906606417686715_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000157266947078280861310000000831918474424425405_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051383193763860147700000002542906606417686715_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040542607941474094460000010083493339302014354_",
    gradientUnits: "userSpaceOnUse",
    x1: -1040.6586,
    y1: -0.1534,
    x2: -1039.6586,
    y2: -0.1534,
    gradientTransform: "matrix(4.5006 48.7929 -48.7929 4.5006 4976.1904 50923.7578)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3FA9F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D76C9"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000040542607941474094460000010083493339302014354_)"
    },
    points: "289.9,171.7 314.7,169.4  316.7,190.7 291.9,193  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000176022101873585114140000018303195315966373546_",
    x: 318.8,
    y: 164.2,
    width: 4.7,
    height: 26.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000110465306966425405260000007772950006002337207_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000176022101873585114140000018303195315966373546_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000110465306966425405260000007772950006002337207_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142863645187122656480000010240891645269447847_",
    gradientUnits: "userSpaceOnUse",
    x1: -1040.6586,
    y1: -0.1539,
    x2: -1039.6586,
    y2: -0.1539,
    gradientTransform: "matrix(4.5006 48.7929 -48.7929 4.5006 4994.2363 50922.0352)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3FA9F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D76C9"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000142863645187122656480000010240891645269447847_)"
    },
    points: "316.4,164.5 323.5,163.8  325.9,190.3 318.9,190.9  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000088112093192736827460000008878886201722494124_",
    d: "M336.2,186.3c-0.8-0.3-1.5-0.7-2.1-1.2 c-1.7-1.5-2.2-3.9-1.3-6c0.3-0.7,0.8-1.3,1.3-1.8c0.6-0.5,1.3-1,2.1-1.2c1.8-0.6,3.8-0.6,5.6,0c0.8,0.3,1.5,0.7,2.1,1.2 c1.7,1.5,2.2,3.9,1.3,6c-0.3,0.7-0.8,1.3-1.3,1.8c-0.6,0.5-1.3,0.9-2.1,1.2C340,186.9,338.1,186.9,336.2,186.3 M334.2,172.3 c-1.3,0.4-2.6,1.2-3.7,2.1c-1,0.8-1.8,1.9-2.3,3.1c-1.1,2.4-1.1,5.1,0,7.5c0.5,1.2,1.3,2.2,2.3,3.1c1.1,0.9,2.3,1.6,3.7,2.1 c3.1,1,6.5,1,9.6,0c1.3-0.5,2.6-1.2,3.6-2.1c1-0.8,1.8-1.9,2.3-3.1c1.1-2.4,1.1-5.1,0-7.5c-0.5-1.2-1.3-2.2-2.3-3.1 c-1.1-0.9-2.3-1.6-3.6-2.1C340.7,171.3,337.4,171.3,334.2,172.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183949208434460697750000009270903450467459730_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000088112093192736827460000008878886201722494124_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000183949208434460697750000009270903450467459730_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050665302534518729470000004068071614768149927_",
    gradientUnits: "userSpaceOnUse",
    x1: -1040.7222,
    y1: -0.1186,
    x2: -1039.7222,
    y2: -0.1186,
    gradientTransform: "matrix(4.41 49 -49 4.41 4920.4751 51140.2266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3FA9F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D76C9"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000050665302534518729470000004068071614768149927_)"
    },
    points: "326.7,173 351.6,170.8  353.6,192.1 328.7,194.4  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000164498056641423342970000005903489631575310505_",
    d: "M362.7,186c-0.7-0.3-1.4-0.6-2-1.1 c-0.5-0.5-1-1.1-1.3-1.7c-0.3-0.7-0.4-1.4-0.4-2.1c0-0.7,0.2-1.4,0.5-2.1c0.3-0.7,0.8-1.3,1.3-1.7c0.6-0.5,1.3-0.9,2.1-1.2 c0.9-0.3,1.9-0.4,2.9-0.4c0.5,0,1.1,0,1.6,0.1c0.6,0.1,1.1,0.2,1.7,0.4c0.6,0.2,1.1,0.4,1.6,0.6c0.5,0.3,1,0.6,1.5,1v6.1 c-0.4,0.4-0.8,0.8-1.3,1.1c-0.5,0.3-1.1,0.6-1.6,0.8c-0.6,0.2-1.2,0.4-1.8,0.5c-0.6,0.1-1.3,0.2-1.9,0.2 C364.5,186.5,363.6,186.3,362.7,186 M360.8,172.2c-1.3,0.4-2.5,1.1-3.5,1.9c-1,0.8-1.8,1.8-2.3,3c-0.6,1.2-0.9,2.6-0.8,3.9 c0,1.3,0.3,2.6,0.8,3.9c0.5,1.1,1.3,2.2,2.2,3c1,0.9,2.1,1.5,3.4,1.9c1.4,0.5,2.8,0.7,4.2,0.7c0.7,0,1.5-0.1,2.2-0.2 c0.7-0.1,1.3-0.3,2-0.5c0.6-0.2,1.2-0.4,1.8-0.7c0.5-0.2,1-0.5,1.4-0.8v0.8c0,0.7-0.1,1.5-0.5,2.1c-0.3,0.7-0.8,1.3-1.4,1.8 c-0.7,0.5-1.5,1-2.3,1.2c-1.1,0.3-2.1,0.5-3.2,0.4c-0.4,0-0.9,0-1.4-0.1c-0.5,0-1.1-0.1-1.6-0.2s-1.2-0.2-1.8-0.3 c-0.6-0.1-1.2-0.3-1.8-0.5l-1.7,3.9c0.7,0.2,1.4,0.4,2.1,0.5s1.5,0.3,2.2,0.4s1.5,0.2,2.2,0.2s1.5,0.1,2.1,0.1 c1.7,0,3.4-0.2,5.1-0.7c1.4-0.4,2.6-1.1,3.7-2c1-0.9,1.8-2,2.3-3.3c0.5-1.4,0.8-3,0.8-4.5v-16.6h-4.7v1.3 c-0.5-0.3-0.9-0.5-1.4-0.7c-0.6-0.2-1.2-0.4-1.7-0.5c-0.6-0.1-1.2-0.3-1.9-0.4c-0.7-0.1-1.3-0.1-2-0.1 C363.6,171.5,362.1,171.7,360.8,172.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000094607909276242836830000001068405033713091768_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000164498056641423342970000005903489631575310505_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000094607909276242836830000001068405033713091768_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109710308379407206460000016737008946017832836_",
    gradientUnits: "userSpaceOnUse",
    x1: -1040.6586,
    y1: -0.1375,
    x2: -1039.6586,
    y2: -0.1375,
    gradientTransform: "matrix(4.5006 48.7929 -48.7929 4.5006 5038.2217 50918.043)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3FA9F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D76C9"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000109710308379407206460000016737008946017832836_)"
    },
    points: "351.5,171.7 376.6,169.4  379.3,198.7 354.2,201  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000115500764398645285590000004612080406799500700_",
    d: "M380.9,190.5h4.7v-18.7h-4.7V190.5z M382,164.5 c-0.4,0.1-0.7,0.3-1,0.5c-0.3,0.2-0.5,0.5-0.6,0.8c-0.3,0.6-0.3,1.3,0,1.9c0.1,0.3,0.4,0.6,0.6,0.8c0.3,0.2,0.6,0.4,1,0.5 c0.4,0.1,0.8,0.2,1.3,0.2c0.4,0,0.9-0.1,1.3-0.2c0.4-0.1,0.7-0.3,1-0.5c0.3-0.2,0.5-0.5,0.6-0.8c0.3-0.6,0.3-1.3,0-1.9 c-0.1-0.3-0.4-0.6-0.6-0.8c-0.3-0.2-0.6-0.4-1-0.5c-0.4-0.1-0.8-0.2-1.3-0.2C382.8,164.3,382.4,164.3,382,164.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000114067900705299040110000009768465410183080090_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000115500764398645285590000004612080406799500700_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000114067900705299040110000009768465410183080090_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148644363923876299150000016892100730729195396_",
    gradientUnits: "userSpaceOnUse",
    x1: -1040.6586,
    y1: -0.1492,
    x2: -1039.6586,
    y2: -0.1492,
    gradientTransform: "matrix(4.5006 48.7929 -48.7929 4.5006 5056.02 50916.3477)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3FA9F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D76C9"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000148644363923876299150000016892100730729195396_)"
    },
    points: "377.8,164.6 386.2,163.8  388.7,190.3 380.3,191.1  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000088840781134250472770000000010737527118569892_",
    d: "M395.8,177.9c0.4-0.5,0.9-0.9,1.4-1.2 c0.6-0.4,1.2-0.6,1.9-0.8c0.8-0.2,1.6-0.3,2.4-0.3c0.8,0,1.5,0.1,2.3,0.3c0.6,0.2,1.3,0.4,1.8,0.8c0.5,0.3,1,0.7,1.3,1.2 c0.3,0.4,0.6,0.9,0.8,1.4H395C395.2,178.8,395.5,178.3,395.8,177.9 M396.3,172.3c-1.3,0.5-2.5,1.2-3.6,2.1 c-1,0.9-1.7,1.9-2.2,3.1c-0.5,1.1-0.8,2.4-0.8,3.6c0,1.3,0.3,2.6,0.8,3.8c0.6,1.2,1.4,2.3,2.4,3.1c1.2,0.9,2.5,1.6,4,2.1 c1.8,0.5,3.7,0.8,5.5,0.8c0.8,0,1.6,0,2.4-0.1s1.5-0.2,2.1-0.3c0.7-0.1,1.3-0.3,2-0.5c0.6-0.2,1.3-0.5,1.9-0.8l-1.6-3.6 c-1,0.3-2,0.6-3.1,0.9c-1.1,0.2-2.1,0.3-3.2,0.3c-1,0-2-0.1-2.9-0.3c-0.8-0.2-1.6-0.4-2.3-0.8c-0.6-0.3-1.2-0.7-1.7-1.2 c-0.4-0.4-0.8-1-1-1.5h17.6c0-0.2,0-0.4,0-0.6c0-0.2,0-0.4,0-0.6c0-1.4-0.3-2.7-0.8-4c-0.5-1.2-1.3-2.4-2.3-3.3 c-1.1-1-2.3-1.7-3.6-2.2C402.9,171.3,399.5,171.3,396.3,172.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000010989862686162540920000012092078929351271613_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000088840781134250472770000000010737527118569892_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000010989862686162540920000012092078929351271613_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137090610255244660570000007589930186264408493_",
    gradientUnits: "userSpaceOnUse",
    x1: -1040.6586,
    y1: -0.1536,
    x2: -1039.6586,
    y2: -0.1536,
    gradientTransform: "matrix(4.5006 48.7929 -48.7929 4.5006 5073.3311 50914.8398)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3FA9F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D76C9"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000137090610255244660570000007589930186264408493_)"
    },
    points: "388,171.7 412.5,169.4  414.5,190.7 390,192.9  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000013177436334598269730000009053801915413393055_",
    d: "M425.4,171.5c-1.3,0-2.6,0.2-3.9,0.6 c-1.1,0.3-2.1,0.8-3,1.4c-0.8,0.5-1.4,1.3-1.9,2.1c-0.4,0.8-0.6,1.7-0.6,2.6c0,0.7,0.1,1.4,0.4,2.1c0.3,0.7,0.7,1.2,1.2,1.7 c0.6,0.5,1.4,0.9,2.2,1.1c1.1,0.3,2.1,0.4,3.2,0.4c0.6,0,1.1,0,1.7-0.1l1.6-0.2l1.5-0.2c0.4-0.1,0.9-0.1,1.3-0.1 c0.7-0.1,1.3,0.1,1.9,0.4c0.4,0.3,0.6,0.7,0.6,1.1c0,0.3-0.1,0.6-0.2,0.9c-0.2,0.3-0.5,0.6-0.9,0.8c-0.5,0.3-1.1,0.5-1.7,0.6 c-0.9,0.2-1.8,0.3-2.7,0.3c-1.6,0-3.1-0.1-4.7-0.5c-1.5-0.3-2.9-0.9-4.2-1.6l-2,3.6c0.7,0.4,1.4,0.7,2.2,1 c0.8,0.3,1.7,0.6,2.6,0.8c0.9,0.2,1.9,0.4,2.9,0.5c1,0.1,2.1,0.2,3.1,0.1c1.6,0,3.1-0.2,4.6-0.6c1.2-0.3,2.3-0.8,3.3-1.5 c0.8-0.6,1.5-1.3,2-2.2c0.4-0.8,0.7-1.8,0.6-2.8c0-0.7-0.1-1.4-0.4-2.1c-0.3-0.7-0.7-1.3-1.2-1.7c-0.6-0.5-1.3-0.9-2.1-1.1 c-1-0.3-1.9-0.4-2.9-0.4c-0.6,0-1.2,0-1.8,0.1l-1.7,0.2L425,179c-0.5,0.1-1,0.1-1.4,0.1c-0.4,0-0.8,0-1.2-0.1 c-0.3,0-0.6-0.1-0.8-0.3c-0.2-0.1-0.3-0.3-0.5-0.5c-0.1-0.2-0.1-0.4-0.1-0.6c0-0.3,0.1-0.6,0.2-0.9c0.2-0.3,0.5-0.6,0.8-0.8 c0.5-0.3,1-0.4,1.5-0.5c0.7-0.2,1.5-0.2,2.2-0.2c1.2,0,2.5,0.1,3.7,0.3c1.2,0.2,2.4,0.6,3.6,1l1.4-3.7c-0.6-0.2-1.3-0.4-1.9-0.6 c-0.7-0.2-1.5-0.3-2.3-0.5c-0.8-0.1-1.6-0.2-2.4-0.3s-1.4-0.1-2.1-0.1L425.4,171.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000124860033801513089240000013355637746796207285_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013177436334598269730000009053801915413393055_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000124860033801513089240000013355637746796207285_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031926148542434566560000004653316391867734178_",
    gradientUnits: "userSpaceOnUse",
    x1: -1040.6586,
    y1: -0.1632,
    x2: -1039.6586,
    y2: -0.1632,
    gradientTransform: "matrix(4.5006 48.7929 -48.7929 4.5006 5097.3931 50912.5273)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3FA9F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D76C9"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000031926148542434566560000004653316391867734178_)"
    },
    points: "413.6,171.7 436.5,169.6  438.4,190.7 415.5,192.8  "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdenGreenLogoMin);
export default __webpack_public_path__ + "static/media/EdenGreenLogo_min.6dba36cd.svg";
export { ForwardRef as ReactComponent };